import { Checkbox } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const OptInCheckbox = ({
  id,
  checked,
  label,
  ariaLabel,
  disabled,
  onToggle
}) => /*#__PURE__*/_jsx(Checkbox, {
  "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label,
  checked: checked,
  disabled: disabled,
  id: id,
  onChange: () => onToggle()
});
export default OptInCheckbox;
//# sourceMappingURL=OptInCheckbox.js.map